import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AdvisorsComponent } from 'src/app/administration/advisors/advisors.component';
import { UserManagement } from 'src/services/api-services/api-interfaces/userManagement.interface';
import { APIUserManagamentService } from 'src/services/api-services/api-user-Management';
import { HelperService } from 'src/services/helperService';


@Component({
    selector: 'app-delete-user',
    templateUrl: './delete-user.dialog.html',
    styleUrls: ['./delete-user.dialog.sass'],
    standalone: false
})
export class DeleteUserDialog implements OnInit {
  isLoadingSave=true;
  constructor(
    @Inject(MAT_DIALOG_DATA) public user: UserManagement,
    public dialogRef: MatDialogRef<AdvisorsComponent>,
    public userManagamentService: APIUserManagamentService,
    public helperService: HelperService,
    private translate: TranslateService,
  ) { }


  ngOnInit(): void {

  }
  //este metodo elimina el usuario por el Id del usuario usuario
  onSave(): void {
    this.isLoadingSave=false
    this.userManagamentService.delete(this.user.userId).subscribe({
      next: (response)=>{
      if(response.code=="200"){
        const translateTextSuccess = this.translate.instant("ToastSuccessDeleteUser",{User:this.user.userName});

        this.helperService.showAlert =true
        this.helperService.typeAlert ="success"
        this.helperService.messageAlert =translateTextSuccess
        setTimeout(() => {
          this.helperService.showAlert =false

        }, 7000)
        this.isLoadingSave=true
        this.dialogRef.close();
      }else{
        const translateTextError = this.translate.instant("ToastErrorDeleteUser", {User:this.user.userName});
        this.helperService.showAlert =true
        this.helperService.typeAlert ="error"
        this.helperService.messageAlert =translateTextError
        setTimeout(() => {
          this.helperService.showAlert =false

        }, 7000)
        this.dialogRef.close();
      }
    },
    error: (failed) => {
      // Manejo de error 401
      if (failed.status === 401) {
        this.helperService.logoutToken();
      }
    }});
  }

  onCancel(): void {
    this.dialogRef.close();

  }

}
